import { beautifyPrice } from "@/utils/price";
import { Box, BoxProps, HStack, Stack, Text } from "@chakra-ui/react";
import Image from "next/image";
import { forwardRef } from "react";
import { I18nLink } from "../i18n/I18nLink";
import { getImageSrc } from "@/utils/file";
import { GiftBox } from "@/types/giftbox";

type Props = {
  giftbox: GiftBox;
} & BoxProps;

const GiftBoxCard = forwardRef<HTMLDivElement, Props>(({ giftbox, ...boxProps }, ref) => {
  return (
    <I18nLink href={`/shop/giftboxes/${giftbox.id}`} passHref>
      <Box
        ref={ref}
        className="product-card"
        px={{ base: "16px", md: "20px" }}
        py={"20px"}
        height={{ base: "400px", sm: "400px", md: "400px" }}
        cursor={"pointer"}
        position="relative"
        overflow="hidden"
        _hover={{ backgroundColor: "#f5f5fd" }}
        {...boxProps}
      >
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          zIndex={0}
        >
          <Image
            src={getImageSrc(giftbox, "main")}
            alt={giftbox?.name ?? "Name"}
            fill
            quality={30}
            style={{ objectFit: "cover" }}
            className="product-image"
            priority
          />
        </Box>
        <Stack
          position="relative"
          zIndex={1}
          height="100%"
          justifyContent="flex-start"
          gap="3px"
        >
          <Text
            className="product-name"
            textStyle={"bold16"}
            as={"b"}
            lineHeight={"20px"}
            lineClamp={2}
            color="white"
            textShadow="0 1px 4px rgba(0,0,0,0.5)"
          >
            {giftbox?.name ?? "Name"}
          </Text>
          <HStack>
            <Text
              as={"b"}
              textStyle={"regular14"}
              className="product-price"
              color="white/50"
            >
              от {beautifyPrice(giftbox?.minPrice)}
            </Text>
          </HStack>
        </Stack>
      </Box>
    </I18nLink>
  );
});

GiftBoxCard.displayName = "GiftBoxCard";
export default GiftBoxCard;